export default "__VITE_ASSET__a77ec6c9__"